import React from 'react';
import { useThemeLanguage } from '../context/ThemeLanguageContext';
import { getTranslation } from '../translations';
import './VideoGuidelines.css';

const TECH_KEYS = ['videoGuidelinesTech1', 'videoGuidelinesTech2', 'videoGuidelinesTech3', 'videoGuidelinesTech4', 'videoGuidelinesTech5'];
const APPROVED_KEYS = ['videoGuidelinesApproved1', 'videoGuidelinesApproved2', 'videoGuidelinesApproved3'];
const NOT_ALLOWED_KEYS = ['videoGuidelinesNotAllowed1', 'videoGuidelinesNotAllowed2', 'videoGuidelinesNotAllowed3', 'videoGuidelinesNotAllowed4', 'videoGuidelinesNotAllowed5', 'videoGuidelinesNotAllowed6'];

export default function VideoGuidelines() {
  const { language } = useThemeLanguage();
  const t = (key) => getTranslation(language, 'landing', key);

  return (
    <section className="landing-video-guidelines" id="video-guidelines">
      <div className="container">
        <h2 className="landing-vg-title">{t('videoGuidelinesTitle')}</h2>
        <p className="landing-vg-subtitle">{t('videoGuidelinesSubtitle')}</p>
        <p className="landing-vg-intro">{t('videoGuidelinesIntro')}</p>

        <div className="landing-vg-block">
          <h3 className="landing-vg-heading">{t('videoGuidelinesPrincipleTitle')}</h3>
          <p className="landing-vg-text">{t('videoGuidelinesPrinciple')}</p>
        </div>

        <div className="landing-vg-block">
          <h3 className="landing-vg-heading">{t('videoGuidelinesTechTitle')}</h3>
          <ul className="landing-vg-list">
            {TECH_KEYS.map((key) => (
              <li key={key}>{t(key)}</li>
            ))}
          </ul>
        </div>

        <div className="landing-vg-block">
          <h3 className="landing-vg-heading">{t('videoGuidelinesApprovedTitle')}</h3>
          <ul className="landing-vg-list">
            {APPROVED_KEYS.map((key) => (
              <li key={key}>{t(key)}</li>
            ))}
          </ul>
        </div>

        <div className="landing-vg-block">
          <h3 className="landing-vg-heading">{t('videoGuidelinesNotAllowedTitle')}</h3>
          <ul className="landing-vg-list landing-vg-list-warn">
            {NOT_ALLOWED_KEYS.map((key) => (
              <li key={key}>{t(key)}</li>
            ))}
          </ul>
        </div>

        <div className="landing-vg-block">
          <h3 className="landing-vg-heading">{t('videoGuidelinesMotionTitle')}</h3>
          <p className="landing-vg-text">{t('videoGuidelinesMotion')}</p>
        </div>

        <div className="landing-vg-block">
          <h3 className="landing-vg-heading">{t('videoGuidelinesBrandingTitle')}</h3>
          <p className="landing-vg-text">{t('videoGuidelinesBranding')}</p>
        </div>

        <div className="landing-vg-block">
          <h3 className="landing-vg-heading">{t('videoGuidelinesApprovalTitle')}</h3>
          <p className="landing-vg-text">{t('videoGuidelinesApproval')}</p>
        </div>

        <p className="landing-vg-tagline">{t('videoGuidelinesTagline')}</p>
      </div>
    </section>
  );
}
